import queryString from "query-string";
import ValidDomains from "../constants/valid-domain-list.json";

const findDomain = () => {
  const values = queryString.parse(window.location.search.toLocaleLowerCase());
  return values.domain;
};

const postMessageToParent = () => {
  const height = document.body.scrollHeight;
  const domain = findDomain();
  if (ValidDomains[domain]) {
    window.parent.postMessage({ height }, "*"); // we don't post sensitive data back, so it's ok to use *
  }
};

export default postMessageToParent;
